import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { IonButton } from '@ionic/vue';
import BaseIcon from '@/components/BaseIcon.vue';
import { Icons } from '@/enums/Icons';

const BLOCK_SELECTOR = 'base-button';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    color: { default: 'primary' },
    expand: {},
    rounded: { type: Boolean, default: false },
    fill: { default: undefined },
    href: {},
    routerLink: {},
    icon: {},
    iconSlot: { default: 'end' }
  },
  setup(__props: any) {

const props = __props;

const buttonClasses = [
  BLOCK_SELECTOR,
  `${BLOCK_SELECTOR}--${props.fill}`,
  `${BLOCK_SELECTOR}--${props.color}`,
  {
    [`${BLOCK_SELECTOR}--rounded`]: props.rounded,
  },
];

const iconClass = [`${BLOCK_SELECTOR}__icon`, `${BLOCK_SELECTOR}__icon--${props.iconSlot}`];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    class: _normalizeClass(buttonClasses),
    color: _ctx.color,
    expand: _ctx.expand,
    href: _ctx.href,
    "router-link": _ctx.routerLink,
    fill: _ctx.fill
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.icon)
        ? (_openBlock(), _createBlock(BaseIcon, {
            key: 0,
            class: _normalizeClass(iconClass),
            icon: _ctx.icon,
            slot: _ctx.iconSlot
          }, null, 8, ["icon", "slot"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["color", "expand", "href", "router-link", "fill"]))
}
}

})